<template>
  <div class="changepassword-client">
    <div class="changepassword-success" v-if="isSuccess === true">
      <div class="messages">
        <p>パスワードを変更しました。</p>
        <el-button type="primary" @click="handleClickTop">トップへ移動する</el-button>
      </div>
    </div>
    <div v-else>
      <div class="messages" v-if="isExpired === true">
        <p>このURLは有効期限が切れているか、無効です。</p>
        <el-button type="primary" @click="handleClickTop">トップへ移動する</el-button>
      </div>
      <el-form
        v-else
        class="changepassword-form"
        :model="changePasswordForm"
        :rules="rules"
        ref="changePasswordForm"
        @submit.native.prevent="submitForm('changePasswordForm')"
        :label-position="labelPosition"
        label-width="200px"
      >
        <div class="messages">
            <span>ご登録されているメールアドレスか携帯電話番号を入力してください</span><br><br>
            <span class="error">{{ this.messages }}</span>
        </div>
        <el-form-item prop="newPassword" label="新しいパスワード">
            <el-input v-model="changePasswordForm.newPassword" type="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="newPasswordConfirm" label="新しいパスワード（確認）">
            <el-input v-model="changePasswordForm.newPasswordConfirm" type="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item class="button-panel">
            <el-button type="primary" native-type="submit">送付する</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import MemberClientApi from '@/api/member/member-client.js'

export default {
  name: 'changepassword-client',
  data () {
    var validatePass = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('新しいパスワードが未入力です。'))
        } else {
            if (this.changePasswordForm.newPassword !== '') {
            this.$refs.changePasswordForm.validateField('newPasswordConfirm')
            }
            callback()
        }
    }
    var validatePass2 = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('新しいパスワード（確認）が未入力です。'))
        } else if (value !== this.changePasswordForm.newPassword) {
            callback(new Error('2つの入力が一致しません。'))
        } else {
            callback()
        }
    }
    return {
      isExpired: false,
      isSuccess: false,
      loginId: null,
      changePasswordForm: {
        newPassword: '',
        newPasswordConfirm: ''
      },
      labelPosition: 'right',
      loading: false,
      messages: '',
      rules: {
        newPassword: [
          { validator: validatePass, trigger: 'blur' }
        ],
        newPasswordConfirm: [
            { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    let iv = this.$route.params.iv
    this.loginId = this.decrypt(this.$route.params.loginId, iv)
    let expiredTime = this.decrypt(this.$route.params.time, iv)
    let nowTime = new Date().getTime()
    if ((nowTime - expiredTime) > 5184000) { // one day
      this.isExpired = true
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            loginId: this.loginId,
            oldPassword: '',
            newPassword: this.changePasswordForm.newPassword
          }
          MemberClientApi.changePass(data).then(response => {
            if (response.status === 200) {
              this.isSuccess = true
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch(err => {
            this.messages = 'エラー'
            this.isSuccess = false
            throw err
          })
        } else {
          return false
        }
      })
    },
    handleClickTop () {
      this.$router.push({ name: 'portal' })
    }
  }
}
</script>

<style scoped>
.changepassword-client {
    padding: 20px;
}
.changepassword-client .messages {
    text-align: center;
    font-weight: bold;
}
.changepassword-client .button-panel {
    text-align: center;
}
</style>
